import { render, staticRenderFns } from "./MyRedemptions.vue?vue&type=template&id=0665a771&"
import script from "./MyRedemptions.js?vue&type=script&lang=js&"
export * from "./MyRedemptions.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports